import { apiRequest } from '@common/api/utils';
import { apiUrl, phoneVerificationUrl } from '@referrals/utils/constants';

function initialLoad() {
  const url = `${apiUrl}/initial-load-data`;
  return apiRequest('GET', url, {});
}

function getLocale(requestedRegion = null) {
  const url = `${apiUrl}/locale`;
  return apiRequest('GET', url, { requested_region: requestedRegion });
}

function requestOtp({
  email, phoneNumber, resend, token,
}) {
  const url = `${phoneVerificationUrl}/phone-otp`;
  return apiRequest(
    'POST',
    url,
    {
      user: {
        phone_number: phoneNumber,
        email,
      },
      resend,
      'g-recaptcha-response': token,
    },
  );
}

function markUserConsent() {
  return apiRequest('GET', `${apiUrl}/user-consent/`);
}

function verifyOtp({ phoneNumber, otp }) {
  const url = `${phoneVerificationUrl}/verify`;
  return apiRequest(
    'POST',
    url,
    {
      user: {
        phone_number: phoneNumber,
        otp,
      },
    },
  );
}

function createActionTracking(activityName) {
  return apiRequest('POST', `${apiUrl}/track-activity/`, {
    activity_name: activityName,
  });
}

function saveBankAccountDetails(fields) {
  return apiRequest('POST', '/academy/mentee-dashboard/save-payment-details', {
    ...fields,
  });
}

export default {
  initialLoad,
  getLocale,
  requestOtp,
  verifyOtp,
  markUserConsent,
  createActionTracking,
  saveBankAccountDetails,
};
